/**
 * Provider factory
 * Single source of truth for resolving a provider name to an instance.
 * Import paths must be static strings so Vite can analyse them at build time.
 *
 * @param {string} providerName - e.g. window.search?.provider
 * @returns {Promise<import('./SearchProvider').default>}
 */
export async function createProvider(providerName) {
  switch (providerName) {
    case 'searchspring': {
      const { default: SearchspringProvider } = await import('@js/providers/search/SearchspringProvider.js');
      return new SearchspringProvider();
    }
    // case 'algolia': {
    //   const { default: AlgoliaProvider } = await import('@js/providers/search/AlgoliaProvider.js');
    //   return new AlgoliaProvider();
    // }
    case 'shopify':
    default: {
      const { default: ShopifyProvider } = await import('@js/providers/search/ShopifyProvider.js');
      return new ShopifyProvider();
    }
  }
}
